import { css } from 'styled-components';
export default css `
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: 0;
  box-shadow: none;
  outline: none;
`;
